import initialState from '../constants/initialState';
import * as types from '../constants/types';

export default (state = initialState, action) => {
	switch (action.type) {
		case types.global.REMOVE_USER:
			return {
				...state,
				articles: {
					all: state.articles.all.filter(article => {
						if (article.user._id === action.payload.userId) {
							return false;
						}

						return {
							...article,
							comments: article.comments.filter(
								comment => comment.user._id !== action.payload.userId,
							),
						};
					}),
				},
			};
		default:
			return state;
	}
};
